import { BaseService, Service } from "/@/cool";
@Service("productTemplate")
class ProductTemplate extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["cateList"] = prefix + "cateList";
		this.permission["list"] = prefix + "list";
		this.permission["save"] = prefix + "save";
		this.permission["saveAuthProduct"] = prefix + "saveAuthProduct";
	}

	cateList(params: any) {
		return this.request({
			url: "/cateList",
			method: "POST",
			data: params
		});
	}

	// 获取分类下的产品列表
	cateProductList(params: any) {
		return this.request({
			url: "/cateProductList",
			method: "POST",
			data: params
		});
	}

	// 获取SKU配置
	skuConfig(params: any) {
		return this.request({
			url: "/skuConfig",
			method: "POST",
			data: params
		});
	}

	bodiesList(params: any) {
		return this.request({
			url: "/bodiesList",
			method: "POST",
			data: params
		});
	}

	status(params: any) {
		return this.request({
			url: "/status",
			method: "POST",
			data: params
		});
	}

	attrList(params: any) {
		return this.request({
			url: "/attrList",
			method: "POST",
			data: params
		});
	}

	// 保存SKU设置
	saveSkuSettings(params: any) {
		return this.request({
			url: "/saveSkuSettings",
			method: "POST",
			data: params
		});
	}
	// 获取SKU设置信息
	skuSettingInfo(params: any) {
		return this.request({
			url: "/skuSettingInfo",
			method: "POST",
			data: params
		});
	}

	// 保存模板
	save(params: any) {
		return this.request({
			url: "/save",
			method: "POST",
			data: params
		});
	}

	// 模板列表
	list(params: any) {
		return this.request({
			url: "/list",
			method: "POST",
			data: params
		});
	}

	saveAuthProduct(params: any) {
		return this.request({
			url: "/saveAuthProduct",
			method: "POST",
			data: params
		});
	}

	// 关联成员
	bindMember(params: any) {
		return this.request({
			url: "/bindMember",
			method: "POST",
			data: params
		});
	}

	// 获取关联成员
	getBindMember(params: any) {
		return this.request({
			url: "/getBindMember",
			method: "POST",
			data: params
		});
	}

	// 获取其他配置
	getOtherConfig(params: any) {
		return this.request({
			url: "/getOtherConfig",
			method: "POST",
			data: params
		});
	}

	// 保存其他配置
	saveOtherConfig(params: any) {
		return this.request({
			url: "/saveOtherConfig",
			method: "POST",
			data: params
		});
	}

	// 更新通用结算配置
	commonSettleUpdate(params: any) {
		return this.request({
			url: "/commonSettleUpdate",
			method: "POST",
			data: params
		});
	}
}
export default ProductTemplate;
